import React from 'react';

const BasePages = props => (
    <div className="wrapper">
        {props.children}
    </div>
)
export default BasePages;
